/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Manager_Addon_FleetInputs */

const en_domain_manager_addon_fleet = /** @type {(inputs: Domain_Manager_Addon_FleetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add-on Fleet`)
};

const es_domain_manager_addon_fleet = /** @type {(inputs: Domain_Manager_Addon_FleetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flota Adicional`)
};

const fr_domain_manager_addon_fleet = /** @type {(inputs: Domain_Manager_Addon_FleetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flotte d'extensions`)
};

const de_domain_manager_addon_fleet = /** @type {(inputs: Domain_Manager_Addon_FleetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add-on-Flotte`)
};

/** @type {(inputs: Domain_Manager_Addon_FleetInputs) => LocalizedString} */
const ja_domain_manager_addon_fleet = en_domain_manager_addon_fleet;

/** @type {(inputs: Domain_Manager_Addon_FleetInputs) => LocalizedString} */
const zh_domain_manager_addon_fleet = en_domain_manager_addon_fleet;

/** @type {(inputs: Domain_Manager_Addon_FleetInputs) => LocalizedString} */
const ar_domain_manager_addon_fleet = en_domain_manager_addon_fleet;

/** @type {(inputs: Domain_Manager_Addon_FleetInputs) => LocalizedString} */
const id_domain_manager_addon_fleet = en_domain_manager_addon_fleet;

/** @type {(inputs: Domain_Manager_Addon_FleetInputs) => LocalizedString} */
const it_domain_manager_addon_fleet = en_domain_manager_addon_fleet;

/** @type {(inputs: Domain_Manager_Addon_FleetInputs) => LocalizedString} */
const ru_domain_manager_addon_fleet = en_domain_manager_addon_fleet;

/** @type {(inputs: Domain_Manager_Addon_FleetInputs) => LocalizedString} */
const pt_domain_manager_addon_fleet = en_domain_manager_addon_fleet;

/** @type {(inputs: Domain_Manager_Addon_FleetInputs) => LocalizedString} */
const ko_domain_manager_addon_fleet = en_domain_manager_addon_fleet;

/**
* | output |
* | --- |
* | "Add-on Fleet" |
*
* @param {Domain_Manager_Addon_FleetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_manager_addon_fleet = /** @type {((inputs?: Domain_Manager_Addon_FleetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Manager_Addon_FleetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_manager_addon_fleet(inputs)
	if (locale === "es") return es_domain_manager_addon_fleet(inputs)
	if (locale === "fr") return fr_domain_manager_addon_fleet(inputs)
	if (locale === "de") return de_domain_manager_addon_fleet(inputs)
	if (locale === "ja") return ja_domain_manager_addon_fleet(inputs)
	if (locale === "zh") return zh_domain_manager_addon_fleet(inputs)
	if (locale === "ar") return ar_domain_manager_addon_fleet(inputs)
	if (locale === "id") return id_domain_manager_addon_fleet(inputs)
	if (locale === "it") return it_domain_manager_addon_fleet(inputs)
	if (locale === "ru") return ru_domain_manager_addon_fleet(inputs)
	if (locale === "pt") return pt_domain_manager_addon_fleet(inputs)
	return ko_domain_manager_addon_fleet(inputs)
});